import React from 'react';
import PropTypes from 'prop-types';

import { ChapterPage } from '../../partials';

export const CenteringContentChapter = ({ name }) => (
  <ChapterPage title={name}>
    <p>This chapter goes into how to use flexbox to center content.</p>
  </ChapterPage>
);

CenteringContentChapter.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/chapters/CenteringContentChapter.js